import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable()
export class ConfigService {
    lobLoader$ = new BehaviorSubject<boolean>(false);
    lobList$ = new BehaviorSubject<any>(null);
    lobListFlat$ = new BehaviorSubject<any>(null);
    refreshLobList$ = new Subject<boolean>();

    supplyLoader$ = new BehaviorSubject<boolean>(false);
    supplyList$ = new BehaviorSubject<any>(null);
    refreshSupplyList$ = new Subject<boolean>();
}

